"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cross_spawn_1 = require("cross-spawn");
function getVersion(command, args) {
    if (args === void 0) { args = []; }
    try {
        var child = cross_spawn_1.sync(command, __spreadArrays(args, ['--version']));
        if (child.status === 0) {
            var output = String(child.output[1]);
            return output.replace(/\n/g, '');
        }
        return null;
    }
    catch (err) {
        return null;
    }
}
exports.default = getVersion;
